// I needed to put this in a separate file because typescript -> javascript converter will put the use below all
// the other imports.

import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)
